import configFile from "../config.json";
import axios from "axios";

export const Client = ({method = 'get', url, data = null}) => {
  return new Promise((resolve, reject) => {
    const headers = {
      'Content-type': 'application/json',
      'Accept': 'application/json',
    };

    const config = {
      url: `${configFile.API_URL}/${url}`,
      method,
      headers,
    }

    if (data) {
      config.data = data;
    }

    axios.request(config)
      .then(response => {
        const { data } = response;
        resolve(data);
      })
      .catch(error => {
        reject({'handle exception': error});
      });
  });
}
